<section>
    <span c-activity-log-blurb activity="activity"></span> {{message}} {{activity.Message|translate}}
</section>